// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-filter[data-v-5bbaeeb0] {\n  background-color: white;\n  overflow-y: auto;\n}\n.select-filter .main-filter[data-v-5bbaeeb0] {\n  width: 47%;\n  min-width: 218px;\n  max-width: 218px;\n  border-right: 1px solid #e4e4e4;\n  margin-right: 20px;\n}\n.select-filter .sub-filter[data-v-5bbaeeb0] {\n  min-width: 218px;\n  height: 100%;\n  flex-grow: 1;\n}", ""]);
// Exports
module.exports = exports;
